export function validate(obj) {
  for (let key in obj) {
    if (obj[key].length <= 2) {
      return false;
    }
  }
  return true;
}
